import React from 'react'
import { Box, Divider } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { useSelector } from 'react-redux'

import useAccounts from '../../hooks/useAccounts'
import { selectLocationPreferred } from '../../redux/selectors/locationSelectors'
import { selectCurrentUser } from '../../redux/modules/selectors'
import HomeLocationWidget from './HomeLocationWidget'
import MyAccounts from './AccountsWidget'
import HomePreferredLocation from './HomePreferredLocation'
import { userHidRequestPreferred } from './requestPreferred'

const HomeSidebar = () => {
  const isPreferredLocation = useSelector(selectLocationPreferred)
  const currentUser = useSelector(selectCurrentUser)
  const showRequestPreferred = !isPreferredLocation && !userHidRequestPreferred(currentUser.userId)

  const { showAccounts, isLoadingPotentialTeams } = useAccounts()
  if (isLoadingPotentialTeams) {
    return <SkeletonLoadingHomeSidebar />
  }

  const showDivider = showRequestPreferred && showAccounts
  return (
    <Box>
      <HomeLocationWidget />
      <Box marginY={4}>
        {showRequestPreferred && <HomePreferredLocation />}
        {showDivider ? (
          <Box width={240} marginY={3}>
            <Divider />
          </Box>
        ) : null}
        {showAccounts && <MyAccounts />}
      </Box>
    </Box>
  )
}

export const SkeletonLoadingHomeSidebar = () => (
  <Box marginTop={5}>
    <Box marginBottom={2}>
      <Skeleton height={240} variant="rect" width={200} />
    </Box>
    <Skeleton height={40} width={150} />
    <Skeleton width={210} />
    <Skeleton width={210} />
    <Skeleton height={70} width={150} />
  </Box>
)

export default HomeSidebar
